import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { Map } from 'shared/map-exports';
import { createRoot, Root } from 'react-dom/client';
import { watchdutyTheme } from 'theme';
import { ForcedTheme } from 'components/ForcedTheme';

export type ThemeMode = 'light' | 'dark';

export type BaseMapboxGLControllerProps = {
  themeMode: ThemeMode;
  forcedThemeMode?: ThemeMode;
};

export abstract class BaseMapboxGLController<
  T extends BaseMapboxGLControllerProps,
> {
  constructor(props: T) {
    this.update(props);
  }

  container: HTMLDivElement | undefined;

  root: Root | undefined;

  map: Map | undefined;

  props: T = {} as T;

  update(props: T): void {
    this.props = props;
  }

  onAdd(map: Map): HTMLDivElement {
    this.map = map;
    this.container = document.createElement('div');
    this.root = createRoot(this.container!);
    this.render();
    return this.container;
  }

  onRemove(): void {
    this.container?.parentNode?.removeChild(this.container);
    this.container = undefined;
    this.root = undefined;
    this.map = undefined;
  }

  render(): void {
    const { forcedThemeMode } = this.props;
    const content = this.content();

    this.container &&
      this.root &&
      this.root.render(
        <StyledEngineProvider injectFirst>
          <ThemeProvider
            theme={watchdutyTheme}
            defaultMode={this.props.themeMode}
            key={this.props.themeMode}
            forceThemeRerender
          >
            {forcedThemeMode ? (
              <ForcedTheme mode={forcedThemeMode}>{content}</ForcedTheme>
            ) : (
              content
            )}
          </ThemeProvider>
        </StyledEngineProvider>,
      );
  }

  abstract content(): JSX.Element;
}
